import { lettersToNumber } from './letterNumber';

/**
 * Sorts configs into display order: ordinary configs A..N first (by
 * letter_number ascending), then the special groups — Warmup before Discards
 * (their sentinel letter_numbers are ordered WARM < DISC by design).
 *
 * letter_number is the sort key of record: comparing the serialized `letter`
 * strings ('WARM'/'DISC', or multi-letter 'AA') mis-orders both the special
 * groups and 27+-config sessions. Payloads without letter_number fall back to
 * decoding `letter`, which round-trips the sentinels via lettersToNumber.
 */
export const sortConfigsByLetter = <T extends { letter?: string; letter_number?: number | null }>(
  configs: T[],
): T[] => {
  const rank = (config: T): number => {
    if (typeof config.letter_number === 'number') {
      return config.letter_number;
    }
    try {
      return config.letter ? lettersToNumber(config.letter) : 0;
    } catch {
      return 0;
    }
  };
  return [...configs].sort((a, b) => rank(a) - rank(b));
};
